/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import Skeleton from "react-loading-skeleton";
import {
    PiArrowBendRightDownThin,
} from "react-icons/pi";
import {useGetTiersQuery} from "../../../services/tiersApi";
import AppStatic from "../../../utils/AppStatic";
import AppButton from "../../../components/button/AppButton";
import {FaEye, FaPencilAlt} from "react-icons/fa";

const AppAmbassadorRank = () => {
    const {
        data: tiers
    } = useGetTiersQuery();

    return (
        <div className="relative text-[#EBE6DE]">
            <div
                className="text-[#AAAAAA] text-lg flex flex-wrap gap-1 items-center text-center justify-center mt-10 md:mt-20">
                {AppStatic.mainAmbassadorRankContinue.ro.translation}
                <PiArrowBendRightDownThin className="text-4xl"/>
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-2 mt-10 gap-5 items-center">
                <div className="lg:pr-10">
                    <h3 className="text-4xl font-bold md:text-6xl mb-6">{AppStatic.mainAmbassadorRankHeading.ro.translation}</h3>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.mainAmbassadorRankFirstHook.ro.translation}</p>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.mainAmbassadorRankSecondHook.ro.translation}</p>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.mainAmbassadorRankThirdHook.ro.translation}</p>
                    <div className="mb-10 mt-10 justify-left flex flex-wrap gap-2">
                        <AppButton data={{
                            action: "scroll",
                            id: "app-contact",
                            extraClass: "border-[#EBE6DE]! text-[#EBE6DE]!",
                            blank: true,
                            name: AppStatic.mainSubscribe.ro.translation,
                            icon: <FaPencilAlt className="f-2"/>
                        }}/>
                        <AppButton data={{
                            action: "scroll",
                            id: "app-ambassador-benefits",
                            extraClass: "bg-[#EBE6DE]! text-black! border-[#EBE6DE]!",
                            blank: true,
                            name: AppStatic.mainViewBenefitsCta.ro.translation,
                            icon: <FaEye className="f-2"/>
                        }}/>
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {tiers && tiers?.length > 0 ? (
                        <>
                            {tiers.map((tier: any, index: number) => (
                                <div key={index}
                                     className={`${tiers.length - 1 === index && `app-ambassador-tier-shadow lg:col-span-2 text-[#232323]! bg-[#EBE6DE]!`} bg-[#232323] border border-[#EBE6DE] rounded-3xl pt-8 pb-8 flex flex-wrap items-center`}>
                                    <div
                                        className={`${tiers.length - 1 === index && ` text-[#EBE6DE]! bg-[#232323]!`} w-full text-6xl text-center bg-[#EBE6DE] text-[#232323]`}>
                                        {tier.percent}%
                                    </div>
                                    <div className="w-full text-right pr-4 mt-4 text-xl">
                                        {tier.name}
                                    </div>
                                    <div className="w-full text-right pr-4 -mb-2 -mt-2 text-base">
                                        {tier.targetSales} {AppStatic.mainAmbassadorRankSales.ro.translation}
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <>
                            <Skeleton count={1} height={200}/>
                            <Skeleton count={1} height={200}/>
                            <Skeleton count={1} height={200}/>
                            <Skeleton count={1} height={200}/>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AppAmbassadorRank;
